import { fetchUnifiedProduct as fetchUnifiedProductByPath } from '@noths/polaris-client-unified-product-service';
import getConfig from 'next/config';

import type { NextConfig } from 'src/types/nextConfig';

const { publicRuntimeConfig } = getConfig() as NextConfig;
const UNIFIED_PRODUCT_SERVICE_ENDPOINT = publicRuntimeConfig.endpoints.unifiedProductService;
const CLIENT_TIMEOUT = 1000;

/**
 * Binds the shared UPS client to this app's config. The package takes the endpoint and the timeout
 * as required arguments by design, so that each consuming app supplies its own validated values
 * rather than the package deciding which UPS to talk to.
 *
 * Throws on every failure, including a 200 carrying a GraphQL `errors` array, and resolves with
 * null when UPS holds no product at that path. Callers own their degradation policy.
 */
export const fetchUnifiedProduct = (productPath: string) =>
  fetchUnifiedProductByPath({
    endpoint: UNIFIED_PRODUCT_SERVICE_ENDPOINT,
    productPath,
    timeout: CLIENT_TIMEOUT,
  });
